import script from "./MoveablePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoveablePanel.vue?vue&type=script&lang=ts&setup=true"

import "./MoveablePanel.vue?vue&type=style&index=0&id=fc791e00&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fc791e00"]])

export default __exports__